import styled from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'

export const BackgroundContainer = styled.div`
  position: relative;
`
export const Layout = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3.6rem 2rem 0;
  margin: 0 auto;

  @media screen and (min-width: 768px) {
    min-height: 36rem;
    max-width: 1060px;
    display: grid;
    grid-auto-columns: 1fr;
    grid-template-columns: 40fr 60fr;
    grid-template-rows: 1fr;
    grid-template-areas: 'Image Form';
    justify-items: center;
  }
`

export const Background = styled(ResponsiveImage)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const FormWrapper = styled.div`
  z-index: 1;
  align-self: center;
  grid-area: Form;
`

export const ImageWrapper = styled.div`
  align-self: center;

  @media screen and (min-width: 768px) {
    width: 100%;
    grid-area: Image;
    align-self: end;
  }
`
